import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      a26(_this__u8e3s4, index) {
        return this.c26(this.b26(_this__u8e3s4, index));
      }
      c26(nestedName) {
        var tmp0_elvis_lhs = this.f26();
        return this.g26(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      b26(descriptor, index) {
        return descriptor.a1q(index);
      }
      g26(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      h26() {
        return this.d26_1.n1() ? '$' : joinToString(this.d26_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.v26(tag);
  var r = block();
  if (!$this.e26_1) {
    $this.w26();
  }
  $this.e26_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.d26_1 = ArrayList().p2();
        this.e26_1 = false;
      }
      g1s() {
        return EmptySerializersModule();
      }
      i26(tag) {
        throw SerializationException().v1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      j26(tag) {
        return true;
      }
      k26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      l26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      m26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      n26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      o26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      p26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      q26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      r26(tag) {
        var tmp = this.i26(tag);
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      s26(tag) {
        var tmp = this.i26(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      t26(tag, enumDescriptor) {
        var tmp = this.i26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      u26(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.v26(tag);
        return this;
      }
      p1r(deserializer, previousValue) {
        return this.q1r(deserializer);
      }
      o1r(descriptor) {
        return this.u26(this.w26(), descriptor);
      }
      c1r() {
        var tmp0_elvis_lhs = this.f26();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.j26(currentTag);
      }
      d1r() {
        return null;
      }
      e1r() {
        return this.k26(this.w26());
      }
      f1r() {
        return this.l26(this.w26());
      }
      g1r() {
        return this.m26(this.w26());
      }
      h1r() {
        return this.n26(this.w26());
      }
      i1r() {
        return this.o26(this.w26());
      }
      j1r() {
        return this.p26(this.w26());
      }
      k1r() {
        return this.q26(this.w26());
      }
      l1r() {
        return this.r26(this.w26());
      }
      m1r() {
        return this.s26(this.w26());
      }
      n1r(enumDescriptor) {
        return this.t26(this.w26(), enumDescriptor);
      }
      r1r(descriptor) {
        return this;
      }
      s1r(descriptor) {
      }
      t1r(descriptor, index) {
        return this.k26(this.a26(descriptor, index));
      }
      u1r(descriptor, index) {
        return this.l26(this.a26(descriptor, index));
      }
      v1r(descriptor, index) {
        return this.m26(this.a26(descriptor, index));
      }
      w1r(descriptor, index) {
        return this.n26(this.a26(descriptor, index));
      }
      x1r(descriptor, index) {
        return this.o26(this.a26(descriptor, index));
      }
      y1r(descriptor, index) {
        return this.p26(this.a26(descriptor, index));
      }
      z1r(descriptor, index) {
        return this.q26(this.a26(descriptor, index));
      }
      a1s(descriptor, index) {
        return this.r26(this.a26(descriptor, index));
      }
      b1s(descriptor, index) {
        return this.s26(this.a26(descriptor, index));
      }
      c1s(descriptor, index) {
        return this.u26(this.a26(descriptor, index), descriptor.d1q(index));
      }
      d1s(descriptor, index, deserializer, previousValue) {
        var tmp = this.a26(descriptor, index);
        return tagBlock(this, tmp, () => this.p1r(deserializer, previousValue));
      }
      f1s(descriptor, index, deserializer, previousValue) {
        var tmp = this.a26(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.a1n().p1p();
          var tmp;
          if (isNullabilitySupported || this.c1r()) {
            tmp = this.p1r(deserializer, previousValue);
          } else {
            tmp = this.d1r();
          }
          return tmp;
        });
      }
      f26() {
        return lastOrNull(this.d26_1);
      }
      v26(name) {
        this.d26_1.i2(name);
      }
      w26() {
        var r = this.d26_1.c5(get_lastIndex(this.d26_1));
        this.e26_1 = true;
        return r;
      }
    }
    protoOf($).e1s = decodeSerializableElement$default;
    protoOf($).q1r = decodeSerializableValue;
    protoOf($).h1s = decodeSequentially;
    protoOf($).j1s = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
